export default class TripAdvisor {
  constructor({ rating, reviews }) {
    this.rating = rating
    this.reviews = reviews || []
    this.hasReviews = rating && rating.reviewCount > 0
  }
}
